module.exports = __webpack_public_path__ + "static/media/prevu_bob.5e87fb23.png";